export default __webpack_public_path__ + "3a36f1cae0df8742fb553bc542ce444a.svg";